<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading || getIsBalanceLoading || getIsAccountSearchLoading">
    <v-card-title>
      Billing Account
      <template v-if="currentLead.account_id===null">
        <v-spacer></v-spacer>
        <v-btn class="mt-0" color="secondary" x-small @click="SET_CREATE_BILLING_OPEN(true)"><v-icon small>add</v-icon></v-btn>
      </template>
    </v-card-title>

    <v-card-text v-if="!currentLeadLoading || !getIsBalanceLoading">
      <v-row>
        <v-col cols="12">
          <p class="mb-1 text-caption">Account ID</p>
          <p><b>
            <template v-if="currentLead.account_id">
              <a href="#" @click.prevent="goToAccount(currentLead.account_id)">{{currentLead.account_id | notEmpty}}</a>
            </template>
            <template v-else>
              {{currentLead.account_id | notEmpty}}
            </template>
          </b></p>

          <p class="mb-1 text-caption">Balance</p>
          <p class="display-1 accent--text">
            {{ getBalance | formatCurrency | notEmpty }}
          </p>
          
          <v-btn v-if="currentLead.account_id" color="primary" class="mt-2" :href="`${ledger_url}payments/${currentLead.account_id}?email=${encodeURIComponent(currentLead.contact.email_address)}`" target="_blank">
            Take Payment
          </v-btn>
        </v-col>

        <v-col v-if="!currentLead.account_id" cols="12">
          <div v-if="getAccountSearch.length">
            <span class="d-flex mb-2">Possibly related accounts found, this might be an existing customer</span>
            <div v-for="(item, i) in getAccountSearch" :key="i">
              <a target="_blank" @click="goToAccount(item.account_id)">{{ item.account_id }} <span v-if="item.business_name">- {{ item.business_name }}</span></a>
            </div>
          </div>
          
          <div v-else>
            <span>No related billing accounts found</span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from "vuex";

  export default {
    data() {
      return {
        ledger_url: process.env.VUE_APP_LEDGER_LINK || `https://ledger-test-bonline.appspot.com/`,
      }
    },

    computed: { 
      ...mapState('leads', ['currentLead','currentLeadLoading']),
      ...mapGetters('leads/accountSearch', ['getAccountSearch','getIsAccountSearchLoading']),
      ...mapGetters('accounts', ['getBalance', 'getIsBalanceLoading']),
    },

    filters: {
      notEmpty: function(val) {
        return (val === null || val === "" || val === undefined)?'-':val;
      }
    },

    methods: {
      ...mapMutations('leads',['SET_CREATE_BILLING_OPEN']),
      goToAccount(id){
        this.$router.push(`/accounts/${id}/`); 
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
